// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cine-fps-range-tooltip .tooltip.tooltip-top {\n  bottom: 85% !important;\n}\n", ""]);
// Exports
module.exports = exports;
